import { createSelector } from 'reselect';

export const getComponentState = state => state.apparelEditor;

export const getTemplateCode = createSelector(
    getComponentState,
    (state) => state.templateCode
);
export const getQuantity = createSelector(
    getComponentState,
    (state) => state.variables.quantity
);
export const getSize = createSelector(
    getComponentState,
    (state) => state.variables.size
);
export const getLogo = createSelector(
    getComponentState,
    (state) => state.variables.logo
);
export const getApparelItem = createSelector(
    getComponentState,
    (state) => state.apparelItem
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getAddingToCart = createSelector(
    getComponentState,
    (state) => state.addingToCart
);
export const getPersons = createSelector(
    getComponentState,
    (state) => state.persons
);
export const getDepartment = createSelector(
    getComponentState,
    (state) => state.department
);
export const getFetchingDepartment = createSelector(
    getComponentState,
    (state) => state.fetchingDepartment
);
export const getCheckingShirtsIndex = createSelector(
    getComponentState,
    (state) => state.checkingShirtsIndex
);
export const getCheckingShirts = createSelector(
    getComponentState,
    (state) => state.checkingShirts
);
export const getManagerClinicName = createSelector(
    getComponentState,
    (state) => state.variables.managerClinicName
);
export const getManagerName = createSelector(
    getComponentState,
    (state) => state.variables.managerName
);
export const getManagerEmail = createSelector(
    getComponentState,
    (state) => state.variables.managerEmail
);
export const getManagerAddress = createSelector(
    getComponentState,
    (state) => state.variables.managerAddress
);
export const getManagerCity = createSelector(
    getComponentState,
    (state) => state.variables.managerCity
);
export const getManagerState = createSelector(
    getComponentState,
    (state) => state.variables.managerState
);
export const getManagerZip = createSelector(
    getComponentState,
    (state) => state.variables.managerZip
);
export const getManagerPhone = createSelector(
    getComponentState,
    (state) => state.variables.managerPhone
);
export const getPersonalizationEnabled = createSelector(
    getComponentState,
    (state) => state.personalizationEnabled
);
export const getIsFavorite = createSelector(
    getComponentState,
    (state) => state.isFavorite
);
export const getAddingFavorite = createSelector(
    getComponentState,
    (state) => state.addingFavorite
);
export const getCheckingFavorite = createSelector(
    getComponentState,
    (state) => state.checkingFavorite
);
export const getSavingWork = createSelector(
    getComponentState,
    (state) => state.savingWork
);
export const getAction = createSelector(
    getComponentState,
    (state) => state.action
);
export const getVariables = createSelector(
    getComponentState,
    (state) => state.variables
);